// 服务类型
<template>
  <div class="detail-wrap" style="overflow: unset!important;
    overflow-y: scroll!important;
    height: 100vh!important; ">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          类型信息
        </div>
        <div class="fr">
          <!-- <el-button type="primary" plain class="button-sty" @click="Reload" icon="el-icon-refresh-right">重置
          </el-button> -->
          <el-button type="primary" class="button-sty" icon="el-icon-check" v-if="serviceTypeEdit && formData.id!=null" @click="upDate">
            保存
          </el-button>
        </div>
      </div>
      <div class="massing">

        <!-- 左边------- 树型结构 -->
        <div class="detail-wrap">
          <div class="user">
            <basic-container>
              <div class="user__tree">
                <div style="display:flex">
                  <el-input placeholder="关键字过滤" v-model="filterText">
                  </el-input>
                  <el-button class="addBtn" type="primary" size="small" @click="openAddTop"
                             style="margin-left: 10px; line-height: 8px; height: 28px;" v-if="serviceTypeSave">添加
                  </el-button>
                </div>

                <!-- 树型结构 -->
                <el-tree class="tree-line" ref="tree" :lazy="true" :data="treeData" :props="props" :load="loadNode"
                         @node-click="nodeClick" :filter-node-method="filterNode" v-if="isRouterAlive"
                >
                  <div class="comp-tr-node" slot-scope="{ node, data }" style="position: relative;">
                    <template>
                      <!-- 名称： 新增节点增加class（is-new） -->
                      <span>{{ node.label }} </span>
                      <!-- 按钮 -->
                      <span style="position: absolute;top: -6px;left: 85px;">
                        <!-- 新增 -->
                        <el-button type="text" v-if="serviceTypeSave && node.level < MAX_LEVEL" size="mini"
                                   @click.stop="() => append(node)">
                          <i slot="default" class="el-icon-circle-plus"></i>
                        </el-button>
                      </span>
                    </template>
                  </div>
                </el-tree>

                <el-dialog style="padding: 40px 20px " :close-on-click-modal="false" :visible.sync="addDialogVisible"
                           width="30%" top="5vh" :show-close="true" :before-close="addHandleClose"
                           :title="addDialogTitle == 'edit' ? '编辑名称' : '新增名称'">
                  <el-form :model="addForm" :rules="addRules" label-width="80px" ref="addRef">
                    <el-form-item label="名称" prop="name">
                      <el-input size="medium" :maxlength="50" v-model="requestParam.serviceTypeName"
                                placeholder="名称"/>
                    </el-form-item>
                  </el-form>
                  <span slot="footer" class="dialog-footer">
                    <el-button size="small" @click="closeAddDialog">取 消</el-button>
                    <el-button size="small" type="primary" @click="addTreeNode">确 定</el-button>
                  </span>
                </el-dialog>
              </div>

            </basic-container>
          </div>
        </div>

        <!-- 右边------- 基本信息 -->

        <div class="detail-wrap" style="height: 100vh;width: calc(100% - 215px);background-color: #fff;">

          <el-tabs v-model="activeName">
            <el-tab-pane label="基本信息" name="first">
              <div>

                <!-- 工单信息 -->
                <!-- 工单信息 -->
                <div class="d-cont edit-mce-box">
                  <div class="d-item">
                    <div class="title first" style="border-top: 1px solid #ededed;">
                      <b>主信息</b>
                    </div>
                    <table class="table-detail">
                      <tbody>
                      <tr>
                        <th>
                          <em class="f-red">*</em>
                          服务名称：
                        </th>
                        <td>
                          <el-input type="text" autocomplete="off" style="width:7vw" v-model="formData.serviceTypeName"
                                    clearable/>
                        </td>

                        <th>
                          <em class="f-red">*</em>
                          父类：
                        </th>
                        <td>
                          <el-form-item :rules="[{ required: true, trigger: 'blur' }]">
                            <el-select v-model="formData.parentId" style="width:7vw" :disabled="true">
                              <el-option v-for="item in topServiceTypeOptions" :key="item.value" :label="item.label"
                                         :value="item.value"/>
                            </el-select>
                          </el-form-item>
                        </td>
                        <th>
                          <em class="f-red">*</em>
                          业务归类费用：
                        </th>
                        <td>
                          <el-form-item prop="businessType" :rules="[{ required: true, trigger: 'blur' }]">
                            <el-select v-model="formData.businessType" style="width:7vw">
                              <el-option label="请选择" :value="0"/>
                              <el-option label="安装" :value="1"/>
                              <el-option label="维修" :value="2"/>
                              <el-option label="保养" :value="3"/>
                              <el-option label="咨询" :value="4"/>
                              <el-option label="退机" :value="5"/>
                              <el-option label="换机" :value="6"/>
                              <el-option label="检测" :value="7"/>
                              <el-option label="鉴定" :value="8"/>
                              <el-option label="勘测" :value="9"/>
                              <el-option label="巡检" :value="10"/>
                              <el-option label="客诉" :value="11"/>
                              <el-option label="送修" :value="12"/>
                              <el-option label="表扬" :value="13"/>
                              <el-option label="设计" :value="14"/>
                              <el-option label="厨改" :value="15"/>
                              <el-option label="其他" :value="19"/>
                            </el-select>
                          </el-form-item>
                        </td>

                        <th>
                          <em class="f-red">*</em>
                          结算归类属性：
                        </th>
                        <td>
                          <el-form-item prop="settleType" :rules="[{ required: true, trigger: 'blur' }]">
                            <el-select v-model="formData.settleType" style="width:7vw">
                              <el-option label="请选择" :value="0"/>
                              <el-option label="安装" :value="1"/>
                              <el-option label="维修" :value="2"/>
                              <el-option label="其他" :value="19"/>
                            </el-select>
                          </el-form-item>
                        </td>
                      </tr>
                      <div style="height:15px"></div>
                      <tr>

                        <th>
                          发布后工单状态：
                        </th>
                        <td>
                          <el-form-item prop="issueStat" :rules="[{ required: true, trigger: 'blur' }]">
                            <el-select v-model="formData.issueStat" style="width:7vw">
                              <el-option label="登记" :value="1"/>
                              <el-option label="发布" :value="2"/>
                              <el-option label="关闭" :value="99"/>
                            </el-select>
                          </el-form-item>
                        </td>
                        <th>
                          是否在微信中显示：
                        </th>
                        <td>
                          <el-radio v-model="formData.isShowwx" :label="0">否</el-radio>
                          <el-radio v-model="formData.isShowwx" :label="1">是</el-radio>
                        </td>
                        <th>
                          是否在发布中显示：
                        </th>
                        <td>
                          <el-radio v-model="formData.isShowIssue" :label="0">否</el-radio>
                          <el-radio v-model="formData.isShowIssue" :label="1">是</el-radio>
                        </td>
                        <th>
                          是否在自建中显示：
                        </th>
                        <td>
                          <el-radio v-model="formData.isShowSiteIssue" :label="0">否</el-radio>
                          <el-radio v-model="formData.isShowSiteIssue" :label="1">是</el-radio>
                        </td>
                      </tr>
                      <div style="height:15px"></div>
                      <tr>
                        <th>
                          是否允许计算远程费：
                        </th>
                        <td>
                          <el-radio v-model="formData.isCountDistanceFee" :label="0">否</el-radio>
                          <el-radio v-model="formData.isCountDistanceFee" :label="1">是</el-radio>
                        </td>
                        <th>
                          完工时是否需要上传条码：
                        </th>
                        <td>
                          <el-radio v-model="formData.isNeedBarcode" :label="0">否</el-radio>
                          <el-radio v-model="formData.isNeedBarcode" :label="1">是</el-radio>
                        </td>
                        <th>
                          是否需要回访：
                        </th>
                        <td>
                          <el-radio v-model="formData.isNeedRecall" :label="0">否</el-radio>
                          <el-radio v-model="formData.isNeedRecall" :label="1">是</el-radio>
                        </td>
                        <th>
                          是否必访：
                        </th>
                        <td>
                          <el-radio v-model="formData.isMustRecall" :label="0">否</el-radio>
                          <el-radio v-model="formData.isMustRecall" :label="1">是</el-radio>
                        </td>
                      </tr>
                      <div style="height:15px"></div>

                      <tr>
                        <th>
                          是否需要网点确认完工：
                        </th>
                        <td>
                          <el-radio v-model="formData.isNeedSiteCheck" :label="0">否</el-radio>
                          <el-radio v-model="formData.isNeedSiteCheck" :label="1">是</el-radio>
                        </td>
                        <th>
                          是否需要预审：
                        </th>
                        <td>
                          <el-radio v-model="formData.isSystemPrecheck" :label="0">否</el-radio>
                          <el-radio v-model="formData.isSystemPrecheck" :label="1">是</el-radio>
                        </td>
                        <th>

                          是否允许网点退单：
                        </th>
                        <td>
                          <el-radio v-model="formData.isAllowSiteReturn" :label="0">否</el-radio>
                          <el-radio v-model="formData.isAllowSiteReturn" :label="1">是</el-radio>
                        </td>
                        <th>

                          是否自定义服务流程：
                        </th>
                        <td>
                          <el-radio v-model="formData.isDefineFlow" :label="0">否</el-radio>
                          <el-radio v-model="formData.isDefineFlow" :label="1">是</el-radio>
                        </td>
                      </tr>
                      <div style="height:15px"></div>
                      <tr>
                        <th>
                          是否DMS显示：
                        </th>
                        <td>
                          <el-radio v-model="formData.isShowDms" :label="0">否</el-radio>
                          <el-radio v-model="formData.isShowDms" :label="1">是</el-radio>
                        </td>
                        <th>
                          是否允许一键回收：
                        </th>
                        <td>
                          <el-radio v-model="formData.isShowRecycle" :label="0">否</el-radio>
                          <el-radio v-model="formData.isShowRecycle" :label="1">是</el-radio>
                        </td>
                        <th>月维修单报单量：</th>
                        <td>
                          <el-input type="text" autocomplete="off" style="width:7vw" v-model="formData.monthFixTopQty" clearable/>
                        </td>
                        <th>编码：</th>
                        <td>
                          <el-input type="text" autocomplete="off" style="width:7vw" v-model="formData.code"
                                    clearable/>
                        </td>
                      </tr>
                      <div style="height:10px"></div>
                      <tr>

                        <th>工单前缀：</th>
                        <td>
                          <el-input type="text" autocomplete="off" :maxlength="3" style="width:7vw" v-model="formData.preCode"
                                    clearable/>
                        </td>
                        <th>排序：</th>
                        <td>
                          <el-input type="number" autocomplete="off" style="width:7vw" v-model="formData.seq"/>
                        </td>

                        <th>服务方式：</th>
                        <td>
                          <el-select clearable v-model="formData.serviceMode" style="width:7vw">
                            <el-option label="到店" :value="2"></el-option>
                            <el-option label="上门" :value="1"></el-option>
                          </el-select>
                        </td>
                        <th>矢量图：</th>
                        <!-- <td class="vector-graphics" colspan="3">
                          <photo-upload :photo-url.sync="formData.pic"/>
                        </td> -->
                        <avue-input-icon v-model="formData.pic" :icon-list="iconList"></avue-input-icon>

                      </tr>

                      <tr>
                        <th>
                          申请关闭是否外呼
                        </th>
                        <td>
                          <el-form-item>
                            <el-select v-model="formData.isCancleOrder">
                              <el-option :value="0" :label="$t('common.No')" />
                              <el-option :value="1" :label="$t('common.yes')" />
                            </el-select>
                          </el-form-item>
                        </td>
                        <th>
                          申请挂起是否外呼
                        </th>
                        <td>
                          <el-form-item>
                            <el-select v-model="formData.isHungUp">
                              <el-option :value="0" :label="$t('common.No')" />
                              <el-option :value="1" :label="$t('common.yes')" />
                            </el-select>
                          </el-form-item>
                        </td>
                        <th>
                          开启派工到人
                        </th>
                        <td>
                            <el-select v-model="formData.kaiqiPaigongDaoren" style="width:7vw">
                              <el-option :value="0" :label="$t('common.No')" />
                              <el-option :value="1" :label="$t('common.yes')" />
                            </el-select>
                        </td>
                        <th>
                          派单合并大类
                        </th>
                        <td>
                          <el-select v-model="formData.paidanHebingDaleiName"
                                     @change="selectHebingDalei" style="width:7vw">
                            <el-option v-for="item in paidanHebingDaleiOption" :key="item.id" :label="item.label"
                                       :value="{ value: item.id, label: item.label }" />
                          </el-select>
                        </td>
                      </tr>


                      <div style="height:10px"></div>

                      <tr class="pop_time">
                        <th>创建人：</th>
                        <td>{{ formData.createBy }}</td>
                        <th>创建时间：</th>
                        <td>{{ formData.createTime }}</td>

<!--                        <th>常用辅材介绍：</th>-->
<!--                        <td>-->
<!--                          <div class="form_picture">-->
<!--                            <photoUpload :photo-url.sync="formData.commonMaterial"/>-->
<!--                          </div>-->
<!--                        </td>-->

                      </tr>
                      <div style="height:15px"></div>
                      </tbody>
                    </table>

                  </div>



                  <!-- 图片 -->
                  <div class="d-item" >
                    <div class="title first" style="border-top: 1px solid #ededed;"><b>完工设置</b></div>
                    <div class="pic_total">
                      <div class="pic_total_items">
                        <div class="pic_p">
                          <p>完工图片1是否必传:</p>
                          <div class="form_pic">
                            <el-select clearable v-model="formData.finishPic1" style="width: 70px!important">
                              <el-option label="否" :value="0"></el-option>
                              <el-option label="是" :value="1"></el-option>
                            </el-select>
                          </div>
                        </div>

                        <div class="form_ename">
                          <span>别名1：</span>
                          <el-input v-model="formData.finishPic1Name"
                                    style="width: 70px !important;margin-left: -3px;"></el-input>
                        </div>

                        <div class="form_picture">
                          <photoUpload :photo-url.sync="formData.pic1"/>
                        </div>
                      </div>

                      <div class="pic_total_items">
                        <div class="pic_p">
                          <p>完工图片2是否必传:</p>
                          <div class="form_pic">
                            <el-select clearable v-model="formData.finishPic2" style="width: 70px">
                              <el-option label="否" :value="0"></el-option>
                              <el-option label="是" :value="1"></el-option>
                            </el-select>
                          </div>
                        </div>

                        <div class="form_ename">
                          <span>别名2：</span>
                          <el-input v-model="formData.finishPic2Name"
                                    style="width: 70px !important;margin-left: -3px;"></el-input>
                        </div>

                        <div class="form_picture">
                          <photoUpload :photo-url.sync="formData.pic2"/>
                        </div>
                      </div>

                      <div class="pic_total_items">
                        <div class="pic_p">
                          <p>完工图片3是否必传:</p>
                          <div class="form_pic">
                            <el-select clearable v-model="formData.finishPic3" style="width: 70px">
                              <el-option label="否" :value="0"></el-option>
                              <el-option label="是" :value="1"></el-option>
                            </el-select>
                          </div>
                        </div>

                        <div class="form_ename">
                          <span>别名3：</span>
                          <el-input v-model="formData.finishPic3Name"
                                    style="width: 70px !important;margin-left: -3px;"></el-input>
                        </div>

                        <div class="form_picture">
                          <photoUpload :photo-url.sync="formData.pic3"/>
                        </div>
                      </div>

                      <div class="pic_total_items">
                        <div class="pic_p">
                          <p>完工图片4是否必传:</p>
                          <div class="form_pic">
                            <el-select clearable v-model="formData.finishPic4" style="width: 70px">
                              <el-option label="否" :value="0"></el-option>
                              <el-option label="是" :value="1"></el-option>
                            </el-select>
                          </div>
                        </div>

                        <div class="form_ename">
                          <span>别名4：</span>
                          <el-input v-model="formData.finishPic4Name"
                                    style="width: 70px !important;margin-left: -3px;"></el-input>
                        </div>
                        <photoUpload :photo-url.sync="formData.pic4"/>
                      </div>

                      <div class="pic_total_items">
                        <div class="pic_p">
                          <p>完工图片5是否必传:</p>
                          <div class="form_pic">
                            <el-select clearable v-model="formData.finishPic5" style="width: 70px">
                              <el-option label="否" :value="0"></el-option>
                              <el-option label="是" :value="1"></el-option>
                            </el-select>
                          </div>
                        </div>

                        <div class="form_ename">
                          <span>别名5：</span>
                          <el-input v-model="formData.finishPic5Name"
                                    style="width: 70px !important;margin-left: -3px;"></el-input>
                        </div>
                        <photoUpload :photo-url.sync="formData.pic5"/>
                      </div>
                      <div class="pic_total_items">
                        <div class="pic_p">
                          <p>完工图片6是否必传:</p>
                          <div class="form_pic">
                            <el-select clearable v-model="formData.finishPic6" style="width: 70px">
                              <el-option label="否" :value="0"></el-option>
                              <el-option label="是" :value="1"></el-option>
                            </el-select>
                          </div>
                        </div>

                        <div class="form_ename">
                          <span>别名6：</span>
                          <el-input v-model="formData.finishPic6Name"
                                    style="width: 70px !important;margin-left: -3px;"></el-input>
                        </div>
                        <photoUpload :photo-url.sync="formData.pic6"/>
                      </div>
                      <div class="pic_total_items">
                        <div class="pic_p">
                          <p>完工图片7是否必传:</p>
                          <div class="form_pic">
                            <el-select clearable v-model="formData.finishPic7" style="width: 70px">
                              <el-option label="否" :value="0"></el-option>
                              <el-option label="是" :value="1"></el-option>
                            </el-select>
                          </div>
                        </div>

                        <div class="form_ename">
                          <span>别名7：</span>
                          <el-input v-model="formData.finishPic7Name"
                                    style="width: 70px !important;margin-left: -3px;"></el-input>
                        </div>
                        <photoUpload :photo-url.sync="formData.pic7"/>
                      </div>
                    </div>
                  </div>
                </div>

                <div style="height: 50px;"></div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="业务节点" name="second">

              <el-button type="primary" class="button-sty btn_zdy" v-if="serviceTypeSave && formData.id!=null"
                         @click="insertEvent()" style="margin-left: 0px;">
                <i class="el-icon-plus"></i>
                添加业务节点
              </el-button>
              <template>
                <div>
                  <vxe-table
                    :stripe="true"
                    :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{height: 30,isHover: true,padding: 0,}"
                    :row-style="{ fontSize: '12px',  }"
                    show-overflow
                    height="300" :column-config="{ resizable: true }"

                    :data="tableData"
                    @cell-dblclick="cellDBLClickEvent">
                    <vxe-column type="seq" width="60" title="序号"></vxe-column>
                    <vxe-column field="processName" title="节点名称"></vxe-column>
                    <vxe-column field="processRemark" title="节点要求说明" :formatter="formatterSex"></vxe-column>
                    <vxe-column field="jsonText" title="节点表单字段">
                      <template #default="{row}">
                        <el-tooltip enterable={false} effect="dark" content="编辑" placement="top"
                                    popper-class="tooltip-skin">
                          <i class="el-icon-edit" style="font-size: 17px; margin-right: 15px;"
                             @click="editEvent(row.id)"/>
                        </el-tooltip>
                      </template>
                    </vxe-column>
                    <vxe-column field="sonJsonText" title="子表单模板" show-overflow>
                      <template #default="{row}">
                        <el-tooltip enterable={false} effect="dark" content="编辑" placement="top"
                                    popper-class="tooltip-skin">
                          <i class="el-icon-edit" style="font-size: 17px; margin-right: 15px;"
                             @click="editEvent(row.id)"/>
                        </el-tooltip>
                      </template>
                    </vxe-column>
                    <vxe-column field="sonProcessName" title="下级节点"></vxe-column>
                    <vxe-column field="processPeriod" title="节点阶段"></vxe-column>

                    <vxe-column title="操作" width="100" v-if="serviceTypeSave">
                      <template #default="{row}">
                        <el-tooltip enterable={false} effect="dark" content="编辑" placement="top"
                                    popper-class="tooltip-skin">
                          <i class="el-icon-edit" style="font-size: 17px; margin-right: 15px;"
                             @click="editEvent(row.id)"/>
                        </el-tooltip>

                        <el-tooltip enterable={false} effect="dark" content="删除" placement="top"
                                    popper-class="tooltip-skin">
                          <i class="el-icon-delete" style="font-size: 17px;" @click="removeEvent(row.id)"></i>
                        </el-tooltip>
                      </template>
                    </vxe-column>
                  </vxe-table>


                </div>
              </template>

            </el-tab-pane>
          </el-tabs>


        </div>


        <!-- 以上右边 -->

      </div>
    </el-form>
    <preconditionDialog v-if="showPreconditionDialog" @commitData="commitData" :sid="formData.id"
                        :visiable.sync="showPreconditionDialog" multi="true" :id="processId"/>
  </div>
</template>

<script>
import photoUpload from "@/components/formItem/photoUpload.vue"
import {
  mapGetters
} from "vuex";
import ExcelUpload from "@/components/upload/excel";
import Tree from '@/components/tree/index'
import store from "@/store";
import api from "@/api/projectApi";
import {dictType, loadDictData} from "@/config/dictType";
import preconditionDialog from "./info.vue";
// 矢量图
import iconList from '@/const/iconListServiceSvg'

export default {
  // inject: ['reload'],
  name: "type",
  components: {
    ExcelUpload, preconditionDialog, photoUpload
  },
  mounted() {
    this.serviceTypeSave = this.permissions['service_type_add']
    this.serviceTypeEdit = this.permissions['service_type_edit']
    this.loadHebingDaleiData()
  },
  data() {
    return {
      iconList: iconList,

      serviceTypeSave: false,
      serviceTypeEdit: false,
      processId: null,
      showPreconditionDialog: false,
      activeName: 'first',
      isShowEdit: false,
      getTreeDataUrl: '/basic/basServiceType/getList',
      treeData: [],
      topServiceTypeOptions: [{label: '无父类', value: '0'}],
      props: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf',
        dataId: 'dataId',
      },
      temp: {
        resolve: '',
        leaf: false
      },
      requestParam: {
        businessType: 0,
        settleType: 0,
        parentId: '',
        serviceTypeName: null,
        usable: 1
      },
      tableData: [],
      paidanHebingDaleiOption:[],//合并大类下拉框
      formData: {
        id: null,
        serviceTypeName: '',  // 服务名称,同厂商下惟一
        parentId: 0,  // 父ID;为0时表示没有父ID
        businessType: 0,  // 业务归类费用:1安装、2维修、3保养、4咨询、5退机、6换机、7、检测、8鉴定、9勘测、10、巡检、19其他
        settleType: 0,  // 结算归类属性:1安装、2维修、29其他
        serviceMode: 1,  // 服务方式：1上门;2到店
        isShowwx: 0,  // 是否在微信中显示:0否1是
        isShowIssue: 0,  // 是否在发布中显示:0否1是
        isShowSiteIssue: 0,  // 是否在自建中显示:0否1是
        issueStat: 2,  // 发布后工单状态：1登记;2发布;99关闭
        isCountDistanceFee: 0,  // 是否允许计算远程费:0否1是
        isNeedBarcode: 0,  // 完工时是否需要上传条码:0否1是
        isNeedRecall: 0,  // 是否需要回访:0否1是
        isMustRecall: 0,  // 是否必访:0否1是
        isNeedSiteCheck: 0,  // 是否需要网点确认完工:0否1是
        isSystemPrecheck: 0,  // 是否需要预审:0否1是
        isAllowSiteReturn: 0,  // 是否允许网点退单:0否1是
        code: null,
        preCode: null,
        pic: null,
        seq: 0,
        isDefineFlow: 0,  // 是否自定义服务流程:0否1是
        finishPic1: 1,  // 完工图片1是否必传:0否1是
        finishPic1Name: '',  // 完工图片1名称
        finishPic2: 1,  // 完工图片2是否必传:0否1是
        finishPic2Name: '',  // 完工图片2名称
        finishPic3: 1,  // 完工图片3是否必传:0否1是
        finishPic3Name: '',  // 完工图片3名称
        finishPic4: 1,  // 完工图片4是否必传:0否1是
        finishPic4Name: '',  // 完工图片4名称
        finishPic5: 0,  // 完工图片5是否必传:0否1是
        finishPic5Name: '',  // 完工图片5名称
        finishPic6: 0,  // 完工图片6是否必传:0否1是
        finishPic6Name: '',  // 完工图片6名称
        finishPic7: 0,  // 完工图片7是否必传:0否1是
        finishPic7Name: '',  // 完工图片7名称

        isShowDms: 0,
        isShowRecycle: 0,
        monthFixTopQty: 0,

        // 完工图片地址
        pic1: null,
        pic2: null,
        pic3: null,
        pic4: null,
        pic5: null,
        pic6: null,
        pic7: null,
      },
      refreshThePicture: true,


      upload_btn1: false,
      upload_btn2: false,
      upload_btn3: false,
      upload_btn4: false,
      upload_btn5: false,
      upload_btn6: false,
      upload_btn7: false,

      disabledCategoryType: false,
      isRouterAlive: true,
      is_new: false,
      // 以上大小ID  类型信息
      filterText: '',
      addType: 1,
      addNode: '',
      _node_level: '',
      NODE_KEY: "id", // id对应字段
      MAX_LEVEL: 2, // 设定最大层级
      NODE_ID_START: 0, // 新增节点id，逐次递减
      startId: null,
      addDataList: "",
      addForm: {
        name: "",
        code: ""
      },
      addRules: {
        name: [{
          required: true,
          message: "请输入名称",
          trigger: "blur"
        }],
        code: [{
          required: true,
          message: "请输入编码",
          trigger: "blur"
        }],
      },
      addDialogTitle: "new",
      addDialogVisible: false,

      searchForm: {},
      tree: {
        categoryName: '',
        categoryCode: "",
        parentId: "",
        categoryType: 1,
        usable: 1
      },
      list: [],
      listLoading: true,
      form: {},
      rolesOptions: [],
      postOptions: [],
      excelUpload: false,

    };
  },
  computed: {
    api() {
      return api
    },
    ...mapGetters(["permissions"]),
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId ? tenantId : '1'
      };
    }
  },


  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    showPreconditionDialog() {
      this.loadProcess(this.formData.id)
    }
  },

  methods: {
    insertEvent() {
      this.showPreconditionDialog = true
      this.processId = null
    },
    editEvent(id) {
      console.log(id, 'row.id')
      this.processId = id
      this.showPreconditionDialog = true
    },
    removeEvent(id) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        this.$http({
          url: api.basServiceTypeProcess.deleteDataUrl,
          method: 'post',
          data: {id: id}
        }).then(res => {
          this.$message.success('删除成功')
          this.loadProcess(this.formData.id)
        })
      })
    },
    // 加载数据字典中服务类型合并大类
    loadHebingDaleiData() {
      loadDictData("服务类型合并大类").then(res => {
        this.paidanHebingDaleiOption = []
        res.data.data.forEach(item => {
          this.paidanHebingDaleiOption.push({
            label: item.label,
            id: item.id
          })
        })
      })
    },
    // 加载父类
    loadTopServiceTypeOptions() {
      this.$http({
        url: this.getTreeDataUrl,
        method: 'post',
        data: {
          parentId: 0,
          usable: 1
        }
      }).then(response => {
        this.topServiceTypeOptions = []
        this.topServiceTypeOptions.push({label: '无父类', value: '0'})
        response.data.data.forEach(item => {
          if (item.id != this.formData.id) {
            this.topServiceTypeOptions.push({
              label: item.serviceTypeName,
              value: item.id
            })
          }
        })
      });
    },

    // 节点加载
    loadNode(node, resolve) {
      if (node.level === 0) {  // 根节点，父id为空
        this.requestData('', resolve, false)
      } else {
        if (node.level < this.MAX_LEVEL - 1) {
          this.requestData(node.data.dataId, resolve, false)
        } else if (node.level === this.MAX_LEVEL - 1) {
          this.requestData(node.data.dataId, resolve, true)
        }
      }
    },

    // 树形控件数据请求
    requestData(parentId, resolve, leaf) {
      this.$http({
        url: this.getTreeDataUrl,
        method: 'post',
        data: {parentId: parentId}
      }).then(res => {
        let array = []
        res.data.data.forEach(item => {
          let obj = {}
          obj.dataId = item.id
          obj.name = item.serviceTypeName
          obj.leaf = !item.hasChild
          array.push(obj)
        })
        resolve(array)
      })
    },

    // 节点点击回显// 节点点击回显
    nodeClick(data) {
      this.refreshThePicture = false
      this.$http({
        url: api.basServiceType.getDataUrl,
        method: 'post',
        data: {id: data.dataId}
      }).then(res => {
        this.isShowEdit = true
        this.formData = res.data.data
        this.loadTopServiceTypeOptions()
        this.refreshThePicture = true

        this.loadProcess(data.dataId)
      })
    },

    // 加载服务类型自定义流程节点
    loadProcess(id) {
      this.$http({
        url: api.basServiceTypeProcess.getListUrl,
        method: 'post',
        data: {serviceTypeId: id}
      }).then(res => {
        this.tableData = res.data.data
      })
    },

    append(node) {
      this.addDialogVisible = true  // 显示新增弹框
      new Promise((resolve, reject) => {
        this.temp.resolve = resolve
        this.temp.leaf = node.level === this.MAX_LEVEL - 1
        this.requestParam.parentId = node.data.dataId
      }).then(newChild => {
        node.isLeaf = false
        this.$refs.tree.append(newChild, node)
      })
    },


    addTreeNode() {
      if (this.requestParam.serviceTypeName == null || this.requestParam.serviceTypeName === '') {
        this.$message.warning('服务类型名称不能为空')
        return
      }
      this.$mask.open()

      this.$http({
        url: '/basic/basServiceType/add',
        method: 'post',
        data: this.requestParam
      }).then(res => {
        if (this.requestParam.parentId === '') {
          this.treeData.push({
            dataId: res.data.data,
            name: this.requestParam.serviceTypeName,
            leaf: true
          })
        } else {
          this.temp.resolve({
            dataId: res.data.data,
            name: this.requestParam.serviceTypeName,
            leaf: this.temp.leaf
          })
          this.reload()
        }
        this.closeAddDialog()
        this.$message.success("保存成功！");
        this.$mask.close()
      }).catch(() => {
              this.$message.error("保存失败！");
              this.$mask.close()
            });
    },

    closeAddDialog() {
      this.addDialogVisible = false
      this.requestParam.serviceTypeName = ''
    },


    addHandleClose() {
      this.addDialogVisible = false;
      this.$refs.addRef.resetFields();
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },

    handleChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },



    // 新增顶级结点
    openAddTop() {
      this.addDialogVisible = true;
      this.addDialogTitle = "new";
      this.requestParam.parentId = ''
    },


    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },

    upDate() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            var url = '/basic/basServiceType/update';
            let formData = this.formData;
            console.log(formData, 'formData的值')
            this.$http({
              url: url,
              method: `post`,
              data: formData,
            }).then(() => {
              this.$message.success("保存成功！");
              this.reload()
            }).catch(e => {
              console.error(e)
              this.$message.error("保存失败！");
            })
          });
        }
      });

    },

    // 重置
    Reload() {
      this.reload()
      this.formData = {}
      this.isShowEdit = false
    },
    //获取服务类型合并大类名称
    selectHebingDalei(data) {
      this.formData.paidanHebingDaleiId = data.value;
      this.formData.paidanHebingDaleiName = data.label;
    },

  },

};

</script>

<style lang="scss" scoped>
.btn_zdy {
  margin: 10px 0;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}


.is_new {
  display: none
}

.d-item {
  border-left: 1px solid #ededed;
}

.el-main {
  display: inline-block;
  height: 791.18px;
}

::v-deep .el-card__body,
.el-main {
  padding: 6px 8px;
  margin: 10px 5px 0px 12px;
  border: 1px solid #ededed;
}

.basic-container {
  padding: 0px 0px 8px 0px !important;
}

.table-detail {
  padding-left: 35px;
  display: inline-block;

  tr th {
    font-weight: 400;
    text-align: right;
    width: 112px;
    font-size: 12px;
    position: relative;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);


  }
}

.pop_time {
  td {
    font-weight: 400;
    text-align: left;
    width: 112px;
    font-size: 12px;
    position: relative;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.title b {
  display: inline-block;
  line-height: 28px;
  font-size: 16px;
  font-weight: 600;
  margin-right: 84px;
  vertical-align: middle;
  color: #00c4b3;
  position: relative;
  z-index: 2;
  background: rgba(42, 100, 148, 0.16);
  margin-left: 0px;
  margin-top: 8px;
  padding-left: 12px;
  padding-right: 14px;
  border-radius: 0 28px 28px 0;
}

.massing {
  display: flex;
  // height: calc(100vh - 94px);

}

.detail-wrap .d-header {
  border-bottom: solid 1px #E9E9E9;
  height: 34px;
  line-height: 34px;
  margin: 7px 0px 6px 12px;
  padding: 0px 24px 0 14px;
  font-size: 13px;
  overflow: hidden;
  background-color: #FFF;
}

.detail-wrap .d-header .fl > i {
  color: #00c4b3;
  display: inline-block;
  vertical-align: middle;
  margin-right: 6px;
  margin-bottom: 1px;
  font-size: 14px;
  font-size: 14px;
}

.d-cont {
  border-bottom: 1px solid #ededed;
  padding-top: 10px;

}

::v-deep[data-v-43ab9747] .el-card__body, .el-main[data-v-43ab9747] {
  padding: 6px 8px;
  border: 1px solid #ededed;
  margin-top: 10px;
  margin-left: 12px;
  margin-right: 5px;
}

.user {
  // height: 802.18px;
  background-color: #fff;
  margin-left: 12px;

  &__tree {
    // padding: 15px;
    // border: 1px solid #ededed;
    width: 192px;
    // height: 755px;
  }

  &__main {
    .el-card__body {
      padding-top: 0;
    }
  }
}

// 装图片的  大框
::v-deep.table-detail .el-upload--picture-card {
  margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 45px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

.basic-container .el-card {
  width: 100%;
  height: 800px;
}


.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep.el-tree {
  width: calc(100% - 32px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: rgba(86, 86, 86, 0.96);
}


// 重新修改tree组件样式
.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }

  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;
    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

// 图片
.pic_total {
  margin-left: 45px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 15px;

  ::v-deep .table-detail.el-upload--picture-card {
    margin: 20px auto !important;
    // margin-left: 30%;
    width: 60px !important;
    height: 60px !important;
    line-height: 65px !important;
  }
  ::v-deep .el-upload--picture-card {
  margin: 20px auto!important;

  // margin-left: 30%;
  width: 60px !important;
  height: 60px !important;
  line-height: 65px !important;
}
  ::v-deep.el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
    width: 60px !important;
    height: 60px !important;
    padding: 0 !important;
  }

  ::v-deep .el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 60px !important;
    height: 60px !important;
    margin-right: 0px !important;
    border-radius: 2px;
    padding: 0px !important;
    border-color: #e8e8e8;
    margin-top: 20px;
    margin-bottom: 10px;
    margin-left: 80%;
  }

  .pic_total_items {
    width: 21%;
    border: 1px solid #e3e3e3;
    height: 200px;
    margin-right: 20px;
    margin-bottom: 20px;

    .pic_p {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;

      p {
        font-size: 12px;
        font-weight: 400;
        width: 110px;
        text-align: right;
        color: #606266;
        display: inline-block;
        word-wrap: break-word;
        white-space: normal;
      }


    }

  }

  .form_pic {
    width: 39%;
    margin-top: 5px;
    margin-left: 2px;
  }

  .form_ename {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    // width: 80%;
    // margin-left: 10%;
    // margin-top: -25px;

    span {
      font-size: 12px;
      font-weight: 400;
      width: 115px;
      line-height: 28px;
      text-align: right;
      color: #606266;
      display: inline-block;
      word-wrap: break-word;
      white-space: normal;
    }
  }
}

.vector-graphics{
::v-deep .el-upload--picture-card {
  margin: 20px 10px !important;

  // margin-left: 30%;
  width: 60px !important;
  height: 60px !important;
  line-height: 65px !important;
}
}
.el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 60px !important;
  height: 60px !important;
  padding: 0 !important;
}

.el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 60px !important;
  height: 60px !important;
  margin-right: 0px !important;
  border-radius: 2px;
  padding: 0px !important;
  border-color: #e8e8e8;
  margin-top: 20px;
  margin-bottom: 10px;
  margin-left: 80%;
}

.table-detail {
  padding: 0 10px;
  display: inline-block;

  tr {

    // margin-bottom: 10px;
    th {
      font-weight: 400;
      text-align: right;
      width: 9vw !important;
      font-size: 12px;
      position: relative;
      padding: 0 10px 0 4px;
      color: rgba(86, 86, 86, 0.96);


    }
  }
}

// 滚动条样式

/* 滚动条 */
::-webkit-scrollbar {
  width: 5px;
  height: 12px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 0px;
  // background: rgba(224, 7, 7, 0.05);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 00px;
  background: #cfcece;
}

::v-deep .vector-graphics {
  .el-upload--picture-card {
    line-height: 70px !important;
  }

  .el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 60px;
    height: 60px;
    margin-right: 14px;
    border-radius: 2px;
    padding: 0 !important;
    border-color: #e8e8e8;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
    width: 60px !important;
    height: 60px !important;
    padding: 0 !important;
  }
}
</style>
